import React from 'react';
import { Row, Col } from "reactstrap";
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';


/**
 *
 * @param props
 */
export const TableEmpty: React.FC<{}> = (): JSX.Element => {

  return (
    <Row>
      <Col sm="12" md="12" className="table-empty text-center">
        <div className="text-secondary">
          <FontAwesomeIcon icon={faSearch} size="4x" rotation={90} />
        </div>
        <div className="lead">
          <FormattedMessage id="datatable_empty"/>
        </div>
      </Col>
    </Row>
  );
}
